import { CourseDetail, SummaryItem } from "../types/course";
import { Role } from "../types/enum";
import { parseGrade } from "./grade";
import { parseMoney } from "./money";

export interface BuildCourseDetailItemsOptions {
    role?: string;
    register?: boolean;
    typeLabel?: string;
    datesLabel?: string;
    includeCategory?: boolean;
    includeResults?: boolean;
    includePrice?: boolean;
    examDateAsArray?: boolean;
}

export const buildCourseDetailItems = (
    courseDetail: CourseDetail | undefined,
    options: BuildCourseDetailItemsOptions = {},
): SummaryItem[] => {
    const {
        role,
        register = false,
        typeLabel = "Naam",
        datesLabel = "Les data",
        includeCategory = false,
        includeResults = true,
        includePrice = true,
        examDateAsArray = true,
    } = options;

    const items: SummaryItem[] = [];
    if (!courseDetail) return items;

    if (includeCategory && courseDetail.category) items.push({ name: "Cursus", variable: courseDetail.category });
    if (courseDetail.type) items.push({ name: typeLabel, variable: courseDetail.type });
    if (courseDetail.registrationDate) items.push({ name: "Inschrijfdatum", variable: courseDetail.registrationDate });
    if (courseDetail.address && courseDetail.place && courseDetail.locationName) {
        items.push({ name: "Locatie", variable: `${courseDetail.locationName}, ${courseDetail.address}, ${courseDetail.place}` });
    }
    if (courseDetail.place && (!courseDetail.locationName || !courseDetail.address)) {
        items.push({ name: "Plaats", variable: courseDetail.place });
    }
    if (courseDetail.certificate) items.push({ name: "Certificaat", variable: courseDetail.certificate });
    if (courseDetail.exam) items.push({ name: "Toets", variable: courseDetail.exam });
    if (courseDetail.dates && courseDetail.dates.length > 0) items.push({ name: datesLabel, variable: courseDetail.dates });
    if (courseDetail.timeSpan) items.push({ name: "Cursus lengte", variable: courseDetail.timeSpan });
    if (courseDetail.frequency) items.push({ name: "Frequentie", variable: courseDetail.frequency });
    if (courseDetail.locations) items.push({ name: "Locaties", variable: courseDetail.locations });
    if (courseDetail.rating) items.push({ name: "Rating", variable: courseDetail.rating });
    if (courseDetail.homeworkSupport) items.push({ name: "Huiswerkbegeleiding", variable: "Huiswerkbegeleiding" });
    if (courseDetail.freeField1) items.push({ name: courseDetail.freeField1Caption || "", variable: courseDetail.freeField1, icon: courseDetail.freeField1Icon });
    if (courseDetail.freeField2) items.push({ name: courseDetail.freeField2Caption || "", variable: courseDetail.freeField2, icon: courseDetail.freeField2Icon });
    if (courseDetail.examDate) items.push({ name: "Examen datum", variable: examDateAsArray ? [courseDetail.examDate] : courseDetail.examDate });

    if (includeResults) {
        if (courseDetail.dateDone) items.push({ name: "Datum afgerond", variable: [courseDetail.dateDone] });
        if (courseDetail.passed === true) items.push({ name: "Geslaagd", variable: "Geslaagd" });
        if (courseDetail.failed === true) items.push({ name: "Afgewezen", variable: "Afgewezen" });
        if (!courseDetail.passed && !courseDetail.failed && courseDetail.dateDone && role !== Role.COMPANY && !courseDetail.expired) {
            items.push({ name: "Resultaat", variable: "Onbekend" });
        }
        if (courseDetail.sampleExamGrade) items.push({ name: "Proefexamen cijfer", variable: parseGrade(courseDetail.sampleExamGrade) });
        if (courseDetail.grade) items.push({ name: "Cijfer", variable: parseGrade(courseDetail.grade) });
        if (courseDetail.theoreticGrade) items.push({ name: "Theorie cijfer", variable: parseGrade(courseDetail.theoreticGrade) });
        if (courseDetail.coachingGrade) items.push({ name: "Coachen & Begeleiden cijfer", variable: parseGrade(courseDetail.coachingGrade) });
        if (courseDetail.portfolioGrade) items.push({ name: "Portfolio cijfer", variable: parseGrade(courseDetail.portfolioGrade) });
        if (courseDetail.presentAtExam === false) items.push({ name: "Afwezig", variable: "Afwezig" });
    }

    if (includePrice && courseDetail.price && courseDetail.btw) {
        items.push({ name: "Prijs per cursist", variable: `${parseMoney(courseDetail.price)} (${courseDetail.btw})` });
    }

    if (includeResults) {
        if (!register && !courseDetail.dateDone && role === Role.COMPANY) items.push({ name: "Status", variable: "Lopend" });
        if (!register && courseDetail.dateDone && role === Role.COMPANY) items.push({ name: "Status", variable: "Afgerond" });
    }

    return items;
};
